/* eslint-disable @typescript-eslint/default-param-last */
import { IZoomGlobalType } from "@/types/zoomClient.types";
import {
  END_INTERVIEW_FOR_ALL,
  LEAVE_INTERVIEW,
  MOVE_CANDIDATE_TO_LOBBY,
  UPDATE_ZOOM_AUDIO_STARTED,
  UPDATE_ZOOM_VIDEO_STARTED,
  UPDATE_ZOOM_CONNECTION_STATUS,
} from "@/constants/ActionTypes";
import initialState from "@/store/initialState";

const zoomGlobalReducer = (
  state = initialState.zoomGlobal,
  action: IZoomGlobalType,
) => {
  switch (action.type) {
    case `${UPDATE_ZOOM_VIDEO_STARTED}_SUCCESS`:
      return {
        ...state,
        zoomVideoStarted: action.payload.zoomVideoStarted,
      };
    case `${UPDATE_ZOOM_AUDIO_STARTED}_SUCCESS`:
      return {
        ...state,
        zoomAudioStarted: action.payload.zoomAudioStarted,
      };
    case `${UPDATE_ZOOM_CONNECTION_STATUS}_SUCCESS`:
      return {
        ...state,
        zoomConnectionStatus: action.payload.zoomConnectionStatus,
      };
    case `${LEAVE_INTERVIEW}_SUCCESS`:
    case `${MOVE_CANDIDATE_TO_LOBBY}_SUCCESS`:
    case `${END_INTERVIEW_FOR_ALL}_SUCCESS`:
      return initialState.zoomGlobal;
    default:
      return state;
  }
};

export default zoomGlobalReducer;
